"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1021,2054],{

/***/ 91021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Sitewide_Navbar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./helpers/common.ts
var common = __webpack_require__(32054);
;// CONCATENATED MODULE: ./helpers/Product.ts

var Product_ProductHelpers = {
    getCollectionVariants: function getCollectionVariants(product) {
        var options = product.options;
        var variants = [];
        if (options.length === 1 && options[0].display_name === "Collection") {
            variants = product.variants;
        }
        if (!variants.length) {
            return [];
        }
        if (variants.every(common.checkVariantNameIsSize)) {
            variants.sort(function(a, b) {
                return parseFloat("".concat(a.calculated_price || 0)) - parseFloat("".concat(b.calculated_price || 0));
            });
        } else {
            variants.sort(function(a, b) {
                if (parseFloat("".concat(b.calculated_price || 0)) > parseFloat("".concat(a.calculated_price || 0))) {
                    return 1;
                }
                if (parseFloat("".concat(a.calculated_price || 0)) === parseFloat("".concat(b.calculated_price || 0))) {
                    if (a.option_values[0].label > b.option_values[0].label) {
                        return 1;
                    }
                }
                return -1;
            });
        }
        return variants;
    },
    getProductAttributeBySku: function getProductAttributeBySku(product, sku) {
        var ref;
        var optionValues = (ref = product.variants.find(function(variant) {
            return variant.sku === sku;
        })) === null || ref === void 0 ? void 0 : ref.option_values;
        return (optionValues === null || optionValues === void 0 ? void 0 : optionValues.reduce(function(accumulator, optionValue) {
            accumulator[optionValue.option_id] = optionValue.id;
            return accumulator;
        }, [])) || [];
    }
};
/* harmony default export */ var Product = ((/* unused pure expression or super */ null && (Product_ProductHelpers)));

// EXTERNAL MODULE: ./services/Log.ts
var Log = __webpack_require__(27429);
// EXTERNAL MODULE: ./helpers/allPromisesWithRetries.ts
var helpers_allPromisesWithRetries = __webpack_require__(48080);
// EXTERNAL MODULE: ./hooks/useContentLoaded.ts
var hooks_useContentLoaded = __webpack_require__(64523);
;// CONCATENATED MODULE: ./hooks/useListrakProductTracking.ts







var useListrakProductTracking = function(product, sku) {
    var collectionVariants = ProductHelpers.getCollectionVariants(product);
    var contentLoaded = useContentLoaded();
    useEffect(function() {
        if (contentLoaded && !product.options.length && !collectionVariants.length) {
            allPromisesWithRetries(function() {
                return [
                    __webpack_require__.e(/* import() */ 3235).then(__webpack_require__.bind(__webpack_require__, 93235))
                ];
            }).then(function(param) {
                var _param = _sliced_to_array(param, 1), ref = _param[0], Listrak = ref.default;
                Listrak.listrakProductBrowse(sku);
            }).catch(error);
        }
    }, [
        contentLoaded,
        sku,
        product,
        collectionVariants
    ]);
};
function areCartItemsSame(cart1, cart2) {
    if (cart1.lineItems.length !== cart2.lineItems.length) {
        return false;
    }
    var itemToPropsString = function(item) {
        return JSON.stringify([
            item.sku,
            item.quantity
        ]);
    };
    var cart1SkuQuantity = new Set(cart1.lineItems.map(itemToPropsString));
    var cart2SkuQuantity = new Set(cart2.lineItems.map(itemToPropsString));
    return !(0,_to_consumable_array/* default */.Z)(cart1SkuQuantity.entries()).find(function(param) {
        var _param = (0,src_sliced_to_array/* default */.Z)(param, 1), sku = _param[0];
        return !cart2SkuQuantity.has(sku);
    });
}
var useListrakCartTracking = function(cart) {
    var cartRef = (0,react.useRef)(cart);
    var contentLoaded = (0,hooks_useContentLoaded/* useContentLoaded */.S)();
    (0,react.useEffect)(function() {
        (0,helpers_allPromisesWithRetries/* default */.Z)(function() {
            return [
                __webpack_require__.e(/* import() */ 3235).then(__webpack_require__.bind(__webpack_require__, 93235))
            ];
        }).then(function(param) {
            var _param = (0,src_sliced_to_array/* default */.Z)(param, 1), ref = _param[0], Listrak = ref.default;
            try {
                if (cart && contentLoaded) {
                    if (cartRef.current) {
                        if (!areCartItemsSame(cart, cartRef.current)) {
                            Listrak.submitCart(cart);
                        }
                    } else {
                        Listrak.submitCart(cart);
                    }
                } else if (cartRef.current) {
                    Listrak.listrakEmptyCart();
                }
            } catch (err) {
                (0,Log/* error */.vU)("Failed to perform useListrakCartTracking", err);
            } finally{
                cartRef.current = cart;
            }
        }).catch(Log/* error */.vU);
    }, [
        cart,
        contentLoaded
    ]);
};

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
;// CONCATENATED MODULE: ./components/Sitewide/Navbar/index.tsx








var MegaNav = dynamic_default()(__webpack_require__.e(/* import() */ 3180).then(__webpack_require__.bind(__webpack_require__, 3180)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3180)
            ];
        }
    }
});
var UserNavigation = dynamic_default()(__webpack_require__.e(/* import() */ 8903).then(__webpack_require__.bind(__webpack_require__, 68903)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68903)
            ];
        }
    }
});
var SearchBox = dynamic_default()(__webpack_require__.e(/* import() */ 8152).then(__webpack_require__.bind(__webpack_require__, 28152)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28152)
            ];
        }
    }
});
var CartPreview = dynamic_default()(__webpack_require__.e(/* import() */ 2850).then(__webpack_require__.bind(__webpack_require__, 92850)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92850)
            ];
        }
    }
});
var MyProfile = dynamic_default()(__webpack_require__.e(/* import() */ 1735).then(__webpack_require__.bind(__webpack_require__, 81735)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81735)
            ];
        }
    }
});
// Extracted  apply from '@csc/csc-sdk'.FP to avoid the import cost of 178 KB
// Apply (take a function then the arg and run it)
// export const apply = f => x => f(x)
var apply = function(f) {
    return function(x) {
        return f(x);
    };
};
var Navbar = function(param) {
    var cart = param.cart, onUpdateCart = param.onUpdateCart, pageType = param.pageType, megaNav = param.megaNav, user = param.user;
    useListrakCartTracking(cart);
    var ref = (0,react.useState)(false), forceMobileExpandedState = ref[0], setForceMobileExpandedState = ref[1];
    var ref1 = (0,react.useState)(""), searchBarQuery = ref1[0], setSearchBarQuery = ref1[1];
    (0,react.useEffect)(function() {
        (0,helpers_allPromisesWithRetries/* default */.Z)(function() {
            return [
                __webpack_require__.e(/* import() */ 4629).then(__webpack_require__.bind(__webpack_require__, 94629))
            ];
        }).then(function(param) {
            var _param = (0,src_sliced_to_array/* default */.Z)(param, 1), ref = _param[0], ExtendWarranty = ref.default;
            return ExtendWarranty.initXMiniCart();
        }).catch(Log/* error */.vU);
    }, []);
    (0,react.useEffect)(function() {
        setForceMobileExpandedState(!!searchBarQuery.length);
    }, [
        searchBarQuery
    ]);
    // Some old Iphones scroll the screen messing the UX when focusing on the field
    // As a solution we force the UX for 500ms after focusing on it
    var onFocus = function() {
        return apply(setForceMobileExpandedState)(true);
    };
    var onBlur = function() {
        return apply(setForceMobileExpandedState)(!!searchBarQuery.length);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "USER_NAVIGATION_ID",
                className: "hidden lg:block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserNavigation, {
                    user: user,
                    cart: cart,
                    onUpdateCart: onUpdateCart,
                    pageType: pageType
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaNav, {
                desktopBreakpoint: "lg",
                logo: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto",
                    style: {
                        maxWidth: "200px",
                        minWidth: "200px",
                        width: "200px",
                        minHeight: "64px",
                        height: "64px",
                        maxHeight: "64px",
                        backgroundImage: "url(".concat(constants.STORE_MAIN_LOGO_URL, ")"),
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center"
                    }
                }),
                smallLogo: constants.STORE_MINI_LOGO_URL,
                megaNavItems: megaNav.meganavItems,
                headerLinks: megaNav.headerLinks,
                mobileNavIcons: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "inline-flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MyProfile, {
                                user: user
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartPreview, {
                                color: "black",
                                cart: cart,
                                onUpdateCart: onUpdateCart,
                                pageType: pageType
                            })
                        ]
                    }, "mobileNavIcons"), 
                ],
                searchBar: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBox, {
                    query: searchBarQuery,
                    setQuery: setSearchBarQuery,
                    id: "MeganavSearchBox",
                    onFocus: onFocus,
                    onBlur: onBlur
                }),
                mobileUserRedirectUrl: user ? "/account" : "/login",
                mobileUserIconText: user ? "Hi, ".concat(user.firstName) : "Log in",
                forceMobileExpandedState: forceMobileExpandedState
            })
        ]
    });
};
/* harmony default export */ var Sitewide_Navbar = (Navbar);


/***/ }),

/***/ 84749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ADDTHIS_ID": function() { return /* binding */ ADDTHIS_ID; },
/* harmony export */   "BOPUS_SHIPPING_DESCRIPTION": function() { return /* binding */ BOPUS_SHIPPING_DESCRIPTION; },
/* harmony export */   "BRAND": function() { return /* binding */ BRAND; },
/* harmony export */   "EXTEND_LOGO": function() { return /* binding */ EXTEND_LOGO; },
/* harmony export */   "EXTEND_SKU": function() { return /* binding */ EXTEND_SKU; },
/* harmony export */   "FOOTER_SECTIONS": function() { return /* binding */ FOOTER_SECTIONS; },
/* harmony export */   "FREE_SHIPPING_AMOUNT": function() { return /* binding */ FREE_SHIPPING_AMOUNT; },
/* harmony export */   "FREE_SHIPPING_DESCRIPTION": function() { return /* binding */ FREE_SHIPPING_DESCRIPTION; },
/* harmony export */   "GIFT_BOX_SKU": function() { return /* binding */ GIFT_BOX_SKU; },
/* harmony export */   "PARKY_CREDIT_CARD_TRANSACTION_METHOD": function() { return /* binding */ PARKY_CREDIT_CARD_TRANSACTION_METHOD; },
/* harmony export */   "PARKY_PAYPAL_TRANSACTION_METHOD": function() { return /* binding */ PARKY_PAYPAL_TRANSACTION_METHOD; },
/* harmony export */   "PLP_Items_Per_Page": function() { return /* binding */ PLP_Items_Per_Page; },
/* harmony export */   "SHIPPED_SHIELD_LOGO": function() { return /* binding */ SHIPPED_SHIELD_LOGO; },
/* harmony export */   "SHIPPED_SHIELD_SKU": function() { return /* binding */ SHIPPED_SHIELD_SKU; },
/* harmony export */   "STANDARD_PLUS_SHIPPING_DESCRIPTION": function() { return /* binding */ STANDARD_PLUS_SHIPPING_DESCRIPTION; },
/* harmony export */   "STANDARD_SHIPPING_DESCRIPTION": function() { return /* binding */ STANDARD_SHIPPING_DESCRIPTION; },
/* harmony export */   "STORE_MAIN_LOGO_URL": function() { return /* binding */ STORE_MAIN_LOGO_URL; },
/* harmony export */   "STORE_MINI_LOGO_URL": function() { return /* binding */ STORE_MINI_LOGO_URL; },
/* harmony export */   "STORE_PHONE": function() { return /* binding */ STORE_PHONE; },
/* harmony export */   "designSkus": function() { return /* binding */ designSkus; },
/* harmony export */   "storeOperationHours": function() { return /* binding */ storeOperationHours; }
/* harmony export */ });
var STORE_PHONE = "(332) 333-6412";
var GIFT_BOX_SKU = "990000007";
var ADDTHIS_ID = "ra-5f4ec39268f6acd2";
var FREE_SHIPPING_AMOUNT = 49.00;
var EXTEND_SKU = ";xtd;";
var SHIPPED_SHIELD_SKU = "SHIPPED_ASSURANCE_";
var BOPUS_SHIPPING_DESCRIPTION = "Zgallerie (BOPS)";
var FREE_SHIPPING_DESCRIPTION = "Free Shipping";
var STANDARD_SHIPPING_DESCRIPTION = "Zgallerie (Standard)";
var STANDARD_PLUS_SHIPPING_DESCRIPTION = "Zgallerie (Standard Plus)";
var STORE_MAIN_LOGO_URL = "https://assets.onekingslane.com/m/2a3672007ee7fa59/original/OKL-logo-reg.png";
var STORE_MINI_LOGO_URL = "data:image/png;base64,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";
var PARKY_CREDIT_CARD_TRANSACTION_METHOD = "Credit Card";
var PARKY_PAYPAL_TRANSACTION_METHOD = "PayPal";
var EXTEND_LOGO = "https://cdn11.bigcommerce.com/s-whvhnri10h/product_images/uploaded_images/extend-logo.png";
var SHIPPED_SHIELD_LOGO = "https://cdn11.bigcommerce.com/s-ccb3mj27tc/products/1821415/images/817186/shield-be9ba978feb179704666141db2d825d1f9d9cc55787fdcbf9885dff04b0dd644__12393.1680276093.220.290.png";
var BRAND = "One Kings Lane";
var PLP_Items_Per_Page = 60;
var FOOTER_SECTIONS = [
    {
        heading: "Our Company",
        links: [
            {
                name: "About Us",
                href: "/about-us"
            },
            {
                name: "Careers",
                href: "/careers"
            },
            {
                name: "Blog",
                href: "https://blog.onekingslane.com/"
            }
        ]
    },
    {
        heading: "Customer Care",
        links: [
            {
                name: "Returns",
                href: "https://returns.narvar.com/okl/returns"
            },
            {
                name: "Order Status",
                href: "/order-status"
            },
            {
                name: "FAQ",
                href: "/faq",
                ariaLabel: "Frequently asked questions"
            },
            {
                name: "Return Policy",
                href: "/faq/#returns-exchange"
            },
            {
                name: "Shipping and Delivery",
                href: "/faq/#shipping-delivery",
                ariaLabel: "Frequently asked questions"
            },
            {
                name: "Request a Swatch",
                href: "/swatch-request"
            },
            {
                name: "Request a Catalog",
                href: "/request-a-catalog-faq"
            },
            {
                name: "Contact Us",
                href: "/contact-us"
            }, 
        ]
    },
    {
        heading: "Resources",
        links: [
            {
                name: "Free Design Services",
                href: "/design-services"
            },
            {
                name: "To the Trade",
                href: "/to-the-trade"
            },
            {
                name: "Affiliates",
                href: "/affiliates-apply-now"
            },
            {
                name: "Farrow & Ball",
                href: "/farrow-ball"
            },
            {
                name: "Protection Plan",
                href: "/extend-faq"
            },
            {
                name: "Citizens Pay\xae",
                href: "/citizens-pay-faq"
            },
            {
                name: "Extend",
                href: "/extend-faq"
            }, 
        ]
    }, 
];
var designSkus = [
    "77469310",
    "77496064",
    "77496065",
    "77496066",
    "77496067",
    "77496068",
    "77496069",
    "77496070",
    "77496203",
    "77534784",
    "77534785",
    "77534786",
    "77534787",
    "77534788",
    "77535257",
    "77535258",
    "77535259",
    "77542926",
    "77542927",
    "77542928",
    "77542929",
    "77542930",
    "77542931",
    "77542932",
    "77542933",
    "77542934",
    "77542935",
    "77542936",
    "77542937",
    "77542938",
    "77542939",
    "77542940",
    "77576646",
    "77576647",
    "77576648",
    "77576649",
    "77576650",
    "77576651", 
];
var storeOperationHours = [
    "Monday-Friday 9 am - 7 pm EST",
    "Weekends & Holidays Closed", 
];


/***/ }),

/***/ 32054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DEFAULT_CHECKOUT_VARIANT": function() { return /* binding */ DEFAULT_CHECKOUT_VARIANT; },
/* harmony export */   "checkVariantNameIsSize": function() { return /* binding */ checkVariantNameIsSize; },
/* harmony export */   "customerGA": function() { return /* binding */ customerGA; },
/* harmony export */   "customerHeap": function() { return /* binding */ customerHeap; },
/* harmony export */   "formatPrice": function() { return /* binding */ formatPrice; },
/* harmony export */   "formatPriceRange": function() { return /* binding */ formatPriceRange; },
/* harmony export */   "getCookieByName": function() { return /* binding */ getCookieByName; },
/* harmony export */   "getCustomerDetails": function() { return /* binding */ getCustomerDetails; },
/* harmony export */   "getCustomerOrderCount": function() { return /* binding */ getCustomerOrderCount; },
/* harmony export */   "getPriceOrPriceRange": function() { return /* binding */ getPriceOrPriceRange; },
/* harmony export */   "getWindowAgent": function() { return /* binding */ getWindowAgent; },
/* harmony export */   "isProductFreeShipping": function() { return /* binding */ isProductFreeShipping; },
/* harmony export */   "priceValue": function() { return /* binding */ priceValue; },
/* harmony export */   "productClickGa": function() { return /* binding */ productClickGa; },
/* harmony export */   "productUpdateGA": function() { return /* binding */ productUpdateGA; },
/* harmony export */   "removeSpecialChars": function() { return /* binding */ removeSpecialChars; },
/* harmony export */   "sizeArray": function() { return /* binding */ sizeArray; },
/* harmony export */   "sleep": function() { return /* binding */ sleep; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _codebuild_output_src3449668696_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src3449668696_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3449668696_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _data_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84749);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27429);
/* harmony import */ var _allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48080);







var getCustomerDetails = function() {
    try {
        var customerDetails = localStorage.getItem("customer");
        if (customerDetails) {
            var ref = JSON.parse(customerDetails), customerId = ref.customerId, customerEmail = ref.customerEmail;
            if ((typeof customerId === "number" || typeof customerId === "string") && typeof customerEmail === "string") {
                return {
                    customerId: customerId,
                    customerEmail: customerEmail
                };
            }
        }
    } catch (err) {
        (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .error */ .vU)("Failed to get customer details from localStorage");
    }
    return {
        customerId: 0,
        customerEmail: ""
    };
};
var kebabCase = function(str) {
    return "".concat(str || "").replace(/([a-z])([A-Z])/g, "$1-$2") // get all lowercase letters that are near to uppercase ones
    .replace(/[\s_]+/g, "-") // replace all spaces and low dash
    .toLowerCase();
};
var productClickGa = function(param) {
    var product = param.product, position = param.position, category = param.category;
    var sendToGA = function() {
        if (true) {
            var customer = getCustomerDetails();
            var customerId = customer === null || customer === void 0 ? void 0 : customer.customerId;
            var customerEmail = customer === null || customer === void 0 ? void 0 : customer.customerEmail;
            var visitorType = customerEmail ? "Logged In" : "Guest";
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                ecommerce: null
            }) // Clear the previous ecommerce object.
            ;
            window.dataLayer.push({
                event: "productClick",
                ecommerce: {
                    visitorType: visitorType,
                    customerId: customerId,
                    click: {
                        actionField: {
                            list: kebabCase(category)
                        },
                        products: [
                            {
                                name: product.name,
                                id: product.variants[0].sku,
                                price: product.calculated_price,
                                brand: product.brand,
                                category: category,
                                variant: product.variants[0].id,
                                position: position
                            }
                        ]
                    }
                },
                customerEmail: customerEmail
            });
        }
    };
    if (window.loadedAndInteractive) {
        sendToGA();
    } else {
        window.addEventListener("loadedAndInteractive", sendToGA, {
            once: true
        });
    }
};
var productUpdateGA = function(lineItem, event, cartTotal) {
    var sendToGA = function() {
        try {
            var ref;
            var customer = getCustomerDetails();
            var customerId = customer === null || customer === void 0 ? void 0 : customer.customerId;
            var customerEmail = customer === null || customer === void 0 ? void 0 : customer.customerEmail;
            var visitorType = customerEmail ? "Logged In" : "Guest";
            var keyName = event === "addToCart" ? "add" : "remove";
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                ecommerce: null
            }) // Clear the previous ecommerce object.
            ;
            var _obj;
            window === null || window === void 0 ? void 0 : (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.push({
                event: event,
                ecommerce: (_obj = {
                    visitorType: visitorType,
                    customerId: customerId
                }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, keyName, {
                    products: [
                        {
                            name: lineItem.name,
                            // for grouped products like quilts, do you have a default that you can use?
                            id: lineItem.sku,
                            // for grouped products like quilts, do you have a default that you can use?
                            price: lineItem.originalPrice,
                            // for grouped products like quilts, do you have a default that you can use?
                            salePrice: lineItem.salePrice,
                            brand: lineItem.brand,
                            variant: lineItem.variantId,
                            quantity: lineItem.quantity
                        }
                    ]
                }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "customerEmail", customerEmail), _obj),
                cartTotal: cartTotal
            });
        } catch (err) {
            (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .error */ .vU)("Failed to send GA event", err);
        }
    };
    if (window.loadedAndInteractive) {
        sendToGA();
    } else {
        window.addEventListener("loadedAndInteractive", sendToGA, {
            once: true
        });
    }
};
var getCustomerOrderCount = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_codebuild_output_src3449668696_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(customerId, customerEmail) {
        var orderCount, ref, ref1, Orders;
        return _codebuild_output_src3449668696_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    orderCount = parseInt(sessionStorage.getItem("customerOrderCount") || "0");
                    if (!(!orderCount && customerId && customerEmail)) {
                        _ctx.next = 13;
                        break;
                    }
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
                    _ctx.next = 5;
                    return (0,_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 1950).then(__webpack_require__.bind(__webpack_require__, 41950))
                        ];
                    });
                case 5:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 1);
                    ref1 = ref[0];
                    Orders = ref1.default;
                    _ctx.next = 11;
                    return Orders.getCustomerOrders({
                        sort: "date_created:desc"
                    });
                case 11:
                    orderCount = _ctx.sent.length;
                    sessionStorage.setItem("customerOrderCount", "".concat(orderCount));
                case 13:
                    return _ctx.abrupt("return", orderCount);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCustomerOrderCount(customerId, customerEmail) {
        return _ref.apply(this, arguments);
    };
}();
var customerGA = function(cartAmount, pageType) {
    var sendToGA = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_codebuild_output_src3449668696_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var customer, customerId, customerEmail, orderCount, ref;
            return _codebuild_output_src3449668696_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        customer = getCustomerDetails();
                        customerId = customer === null || customer === void 0 ? void 0 : customer.customerId;
                        customerEmail = customer === null || customer === void 0 ? void 0 : customer.customerEmail;
                        _ctx.next = 5;
                        return getCustomerOrderCount(customerId, customerEmail);
                    case 5:
                        orderCount = _ctx.sent;
                        try {
                            ;
                            window === null || window === void 0 ? void 0 : (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.push({
                                event: "customer",
                                visitorType: customerId ? "Logged In" : "Guest",
                                customerId: customerId,
                                customerEmail: customerEmail,
                                customerOrdersCount: orderCount,
                                customerTotalSpent: "",
                                cartTotal: cartAmount,
                                pageType: pageType
                            });
                        } catch (err) {
                            (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .error */ .vU)("Failed to send customer to GA", err);
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function sendToGA() {
            return _ref.apply(this, arguments);
        };
    }();
    if (window.loadedAndInteractive) {
        sendToGA().catch(_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .error */ .vU);
    } else {
        window.addEventListener("loadedAndInteractive", function() {
            sendToGA().catch(_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .error */ .vU);
        }, {
            once: true
        });
    }
};
var customerHeap = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_codebuild_output_src3449668696_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(pageType) {
        var customer, customerId, customerEmail, ref, orderCount, ref1, ref2, identify;
        return _codebuild_output_src3449668696_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    customer = getCustomerDetails();
                    customerId = customer === null || customer === void 0 ? void 0 : customer.customerId;
                    customerEmail = customer === null || customer === void 0 ? void 0 : customer.customerEmail;
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
                    _ctx.next = 6;
                    return Promise.all([
                        getCustomerOrderCount(customerId, customerEmail),
                        (0,_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                            return [
                                __webpack_require__.e(/* import() */ 8063).then(__webpack_require__.bind(__webpack_require__, 28063))
                            ];
                        }), 
                    ]);
                case 6:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 2);
                    orderCount = ref[0];
                    ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(ref[1], 1);
                    ref2 = ref1[0];
                    identify = ref2.default;
                    identify({
                        visitorType: customerId ? "Logged In" : "Guest",
                        customerId: customerId,
                        customerEmail: customerEmail,
                        customerOrderCount: orderCount,
                        pageType: pageType
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function customerHeap(pageType) {
        return _ref.apply(this, arguments);
    };
}();
var formatPrice = function(price) {
    var digit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    // using parseFloat to make sure this function works for both number and string
    var floatPrice = parseFloat("".concat(price || ""));
    if (!Number.isFinite(floatPrice)) {
        return price;
    }
    return "$".concat(parseFloat("".concat(price || "")).toFixed(digit));
};
// using parseFloat to make sure this function works for both number and string
var formatPriceRange = function(minPrice, maxPrice) {
    var digit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    return "".concat(formatPrice(minPrice, digit) || "", " - ").concat(formatPrice(maxPrice, digit) || "");
};
var getPriceOrPriceRange = function(product, priceType) {
    var ref;
    var variants = product.variants;
    var sortedVariantPrices = (ref = variants === null || variants === void 0 ? void 0 : variants.map(function(variant) {
        return parseFloat("".concat(variant[priceType]));
    })) === null || ref === void 0 ? void 0 : ref.sort();
    var minPrice = variants ? sortedVariantPrices[0] : product[priceType];
    var maxPrice = variants ? sortedVariantPrices.pop() : product[priceType];
    return minPrice === maxPrice ? formatPrice(minPrice) : formatPriceRange(minPrice, maxPrice);
};
var sizeArray = [
    "small",
    "medium",
    "large",
    "extra small",
    "extra large",
    "long",
    "tall",
    "short"
];
var checkVariantNameIsSize = function(el) {
    var name = el.option_values[0].label.toLowerCase();
    if (/^\d/.test(name) || sizeArray.includes(name)) {
        return true;
    }
    return false;
};
var priceValue = function(price) {
    return price.split("$")[1];
};
var isProductFreeShipping = function(price) {
    var freeShipping = false;
    var consideredPrice = "".concat(price);
    if (consideredPrice.includes("-")) {
        freeShipping = consideredPrice.split("-").some(function(value) {
            return parseFloat(priceValue(value)) >= _data_constants__WEBPACK_IMPORTED_MODULE_1__.FREE_SHIPPING_AMOUNT;
        });
    } else {
        freeShipping = parseFloat(priceValue(consideredPrice)) >= _data_constants__WEBPACK_IMPORTED_MODULE_1__.FREE_SHIPPING_AMOUNT;
    }
    return freeShipping;
};
var removeSpecialChars = function(string) {
    var regex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /[^a-zA-Z \s0-9,'\-#.*&]/g;
    return "".concat(string).replace(regex, "");
};
var getCookieByName = function(name) {
    var ref, ref1, ref2, ref3;
    var cookieName = (ref2 = globalThis === null || globalThis === void 0 ? void 0 : (ref = globalThis.document) === null || ref === void 0 ? void 0 : (ref1 = ref.cookie) === null || ref1 === void 0 ? void 0 : ref1.split(";")) === null || ref2 === void 0 ? void 0 : ref2.find(function(cookie) {
        return cookie.includes(name);
    });
    return (ref3 = cookieName === null || cookieName === void 0 ? void 0 : cookieName.split("=")) === null || ref3 === void 0 ? void 0 : ref3[1];
};
// IDs for each variant within an experiment are numeric and indexed at 0
var DEFAULT_CHECKOUT_VARIANT = "0";
var sleep = function(ms) {
    return new Promise(function(r) {
        return setTimeout(r, ms);
    });
};
var getWindowAgent = function(nextContextReq) {
    // Ref: https://stackoverflow.com/questions/59494037/how-to-detect-the-device-on-react-ssr-app-with-next-js
    // if you are on the server and you get a 'nextContextReq' property from your context
    if (nextContextReq) {
        // get the user-agent from the headers
        return nextContextReq.headers["user-agent"];
    }
    // if you are on the client you can access the navigator from the window object
    return navigator.userAgent;
};


/***/ }),

/***/ 64523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useContentLoaded; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var domLoadedEvents = [
    "DOMContentLoaded",
    "load"
];
var userInteractionEvents = [
    "mousemove",
    "scroll",
    "keydown",
    "keypress",
    "keyup",
    "mouseenter", 
];
var useContentLoaded = function() {
    var loadedAndInteractive =  true && window.loadedAndInteractive === true;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(loadedAndInteractive), domLoaded = ref[0], setDomLoaded = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(loadedAndInteractive), userInteracted = ref1[0], setUserInteracted = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!domLoaded && !loadedAndInteractive) {
            var domLoaderWatcher = function() {
                return setDomLoaded(true);
            };
            domLoadedEvents.forEach(function(event) {
                return window.addEventListener(event, domLoaderWatcher, {
                    capture: true,
                    once: true
                });
            });
            return function() {
                return domLoadedEvents.forEach(function(event) {
                    return window.removeEventListener(event, domLoaderWatcher);
                });
            };
        }
        return function() {};
    }, [
        domLoaded,
        loadedAndInteractive
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!userInteracted && !loadedAndInteractive) {
            var userInteractionWatcher = function() {
                return setUserInteracted(true);
            };
            userInteractionEvents.forEach(function(event) {
                return window.addEventListener(event, userInteractionWatcher, {
                    capture: true,
                    once: true
                });
            });
            try {
                var iframes = document.getElementsByTagName("iframe");
                userInteractionEvents.forEach(function(event) {
                    (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(iframes).forEach(function(iframe) {
                        iframe.addEventListener(event, userInteractionWatcher, {
                            capture: true,
                            once: true
                        });
                    });
                });
            } catch (e) {
            // Fail silently
            }
            return function() {
                userInteractionEvents.forEach(function(event) {
                    return window.removeEventListener(event, userInteractionWatcher);
                });
                try {
                    var iframes = document.getElementsByTagName("iframe");
                    userInteractionEvents.forEach(function(event) {
                        (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(iframes).forEach(function(iframe) {
                            iframe.removeEventListener(event, userInteractionWatcher);
                        });
                    });
                } catch (e) {
                // Fail silently
                }
            };
        }
        return function() {};
    }, [
        userInteracted,
        loadedAndInteractive
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (domLoaded && userInteracted && !window.loadedAndInteractive) {
            window.loadedAndInteractive = true;
            window.dispatchEvent(new Event("loadedAndInteractive"));
        }
    }, [
        domLoaded,
        userInteracted
    ]);
    return domLoaded && userInteracted || loadedAndInteractive;
};
/* harmony default export */ __webpack_exports__["Z"] = (useContentLoaded);


/***/ })

}]);